import { ConnectionDetails, convertConnectionToDetails, mergeConnectionDetails as merge } from '@/utils/custom';
import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  DispatchSummaryMarket,
  DispatchSummaryMarketSearch,
  SearchDispatchSummaryMarketResponseDispatchSummaryMarketConnectionArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { SearchDispatchSummaryMarket } from '@/features/SummaryHistory/api/queries/SearchDispatchSummaryMarket';
// Service Function Signature
type ServiceMethodPayload = ({
  startDateTime?: string;
  endDateTime?: string;
} & {
  [key in keyof DispatchSummaryMarketSearch]?: any[];
})[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<DispatchSummaryMarket>>;
}

// SearchDispatchSummaryMarket Service
export const { searchDispatchSummaryMarket, refetchDispatchSummaryMarket, useDispatchSummaryMarket } = ((): {
  searchDispatchSummaryMarket: ServiceMethod;
  refetchDispatchSummaryMarket: ServiceMethod;
  useDispatchSummaryMarket: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(SearchDispatchSummaryMarket).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<DispatchSummaryMarket>> => {
        const args: SearchDispatchSummaryMarketResponseDispatchSummaryMarketConnectionArgs = {
          input: {
            first: options?.pageSize || null,
            after: options?.pageSize > 0 ? (options?.pageSize * options?.page).toString() : null,
            query: payload,
          },
        };
        const opts = { merge: options?.merge ? 'searchDispatchSummaryMarket.dispatchSummaryMarketConnection' : undefined };
        const res = await fn(args, opts);
        return convertConnectionToDetails(getProperty('searchDispatchSummaryMarket.dispatchSummaryMarketConnection', res));
      }
  );
  const useService = createGraphApiHook(fetch, { refetch, merge });
  return {
    searchDispatchSummaryMarket: fetch,
    refetchDispatchSummaryMarket: refetch,
    useDispatchSummaryMarket: useService,
  };
})();
